export default __webpack_public_path__ + "static/media/home_icon.3d3630f1.svg";